import SideNav from "./SideNav";
import { Paper } from "@mui/material";
import User01 from "../../../Svg/User01";
import React, { useContext } from "react";
import constants from "../../../constants";
import TrendUp01 from "../../../Svg/TrendUp01";
import ChevronLeft from "../../../Svg/ChevronLeft";
import { getDataFromStorage } from "../../../util";
import TestSvgIcon from "../../../Svg/TestSvgIcon";
import { Outlet, useLocation } from "react-router-dom";
import AlertContext from "../../../context/AlertContext";
import CheckVerified01 from "../../../Svg/CheckVerified01";
import GraduationHat01 from "../../../Svg/GraduationHat01";
import { ProfileContext } from "../../../context/ProfileContext";
import Loading from "../../Notification-Loading/Loading/Loading";

const paperStyle = {
  width: "76%",
  display: "block",
  overflow: "auto",
  boxShadow: "none",
  borderRadius: "10px",
  margin: "4px 25px 0 0px",
  border: "1px solid #EAECF0",
};

const Profile = () => {
  const { isLoaded } = useContext(AlertContext);
  const { navigate, onSaveProfileDetails } = useContext(ProfileContext);

  const { pathname } = useLocation();

  const menuListItemsStudent = [
    {
      id: 1,
      path: "personalinfo",
      text: "Personal Info",
      active: pathname.includes("personalinfo"),
      icon: (
        <User01
          width="20"
          height="20"
          strokeWidth="1.6"
          stroke={pathname.includes("personalinfo") ? "#FCFCFD" : "#667085"}
        />
      ),
    },
    {
      id: 2,
      path: "parentinfo",
      text: "Parent Info",
      active: pathname.includes("parentinfo"),
      icon: (
        <User01
          width="20"
          height="20"
          strokeWidth="1.6"
          stroke={pathname.includes("parentinfo") ? "#FCFCFD" : "#667085"}
        />
      ),
    },
    {
      id: 3,
      text: "Education",
      path: "education",
      active: pathname.includes("education"),
      icon: (
        <GraduationHat01
          width="20"
          height="20"
          strokeWidth="1.6"
          stroke={pathname.includes("education") ? "#FCFCFD" : "#667085"}
        />
      ),
    },
    {
      id: 4,
      path: "academic",
      text: "Academic Work",
      active: pathname.includes("academic"),
      icon: (
        <TrendUp01
          width="20"
          height="20"
          strokeWidth="1.6"
          stroke={pathname.includes("academic") ? "#FCFCFD" : "#667085"}
        />
      ),
    },
    {
      id: 5,
      path: "socialprofile",
      text: "Social Profiles",
      active: pathname.includes("socialprofile"),
      icon: (
        <CheckVerified01
          width="20"
          height="20"
          strokeWidth="1.6"
          stroke={pathname.includes("socialprofile") ? "#FCFCFD" : "#667085"}
        />
      ),
    },
    {
      id: 7,
      path: "viewresume",
      text: "View Resume",
      active: pathname.includes("viewresume"),
      icon: (
        <TestSvgIcon
          width="20"
          libType={1}
          height="20"
          strokeWidth="1.6"
          component="resume"
          stroke={pathname.includes("viewresume") ? "#FFFFFF" : "#344054"}
        />
      ),
    },
    {
      id: 8,
      path: "studentremarks",
      text: "Trainer Feedback",
      active: pathname.includes("studentremarks"),
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.50008 12.9167H6.25009C5.08711 12.9167 4.50563 12.9167 4.03246 13.0602C2.96713 13.3834 2.13345 14.217 1.81028 15.2824C1.66675 15.7555 1.66675 16.337 1.66675 17.5M12.0834 6.25C12.0834 8.32107 10.4045 10 8.33342 10C6.26235 10 4.58341 8.32107 4.58341 6.25C4.58341 4.17893 6.26235 2.5 8.33342 2.5C10.4045 2.5 12.0834 4.17893 12.0834 6.25ZM9.16675 17.5L11.7512 16.7616C11.875 16.7262 11.9369 16.7085 11.9946 16.682C12.0458 16.6585 12.0945 16.6298 12.14 16.5965C12.1912 16.5589 12.2367 16.5134 12.3277 16.4224L17.7085 11.0417C18.2838 10.4664 18.2838 9.53362 17.7084 8.95831C17.1331 8.38302 16.2004 8.38303 15.6251 8.95833L10.2444 14.339C10.1534 14.43 10.1079 14.4756 10.0703 14.5267C10.0369 14.5722 10.0082 14.6209 9.98471 14.6722C9.95821 14.7299 9.94053 14.7918 9.90516 14.9155L9.16675 17.5Z"
            stroke={pathname.includes("studentremarks") ? "#FFFFFF" : "#344054"}
            stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
    },
  ];

  const menuListItemsAdmin = [
    {
      id: 1,
      path: "personalinfo",
      text: "Personal Info",
      active: pathname.includes("personalinfo"),
      icon: (
        <User01
          width="20"
          height="20"
          strokeWidth="1.6" 
          stroke={pathname.includes("personalinfo") ? "#FCFCFD" : "#667085"}
        />
      ),
    },
    {
      id: 2,
      path: "socialprofile",
      text: "Social Profiles",
      active: pathname.includes("socialprofile"),
      icon: (
        <CheckVerified01
          width="20"
          height="20"
          strokeWidth="1.6"
          stroke={pathname.includes("socialprofile") ? "#FCFCFD" : "#667085"}
        />
      ),
    },
  ];

  return (
    <section
      className={
        getDataFromStorage("role") === constants.Roles.learner
          ? "profileContainerLearner"
          : "profileContainerAdmin"
      }
    >
      <div className="profileBackBtnSec">
        <div
          className="profileBackBtn"
          onClick={() => {
            navigate(-1);
          }}
        >
          <ChevronLeft />
          <p className="profileBackBtnText">Back</p>
        </div>
      </div>
      <div className="profileInfoSection">
        <SideNav
          title="Profile"
          onMenuClick={onSaveProfileDetails}
          menuListItems={
            getDataFromStorage("role") === constants.Roles.admin ||
            getDataFromStorage("role") === constants.Roles.trainer ||
            getDataFromStorage("role") === constants.Roles.super_admin
              ? menuListItemsAdmin
              : menuListItemsStudent
          }
        />
        <Paper sx={paperStyle} className="personalInfoSec">
          <Outlet />
        </Paper>
      </div>
      {isLoaded && <Loading />}
    </section>
  );
};

export default Profile;
